import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AuthSignalService {

    constructor() { }
    login_subject = new BehaviorSubject<boolean>(false);
    forgot_password_subject = new BehaviorSubject<boolean>(false);
    signup_subject = new BehaviorSubject<boolean>(false);

    is_login_success = new BehaviorSubject<boolean>(
        globalThis.window?.localStorage
            ? !!localStorage.getItem('token')
            : false
    );

    /** Emit true when Edit Profile is clicked from profile-status-popup while already on my-profile page */
    openEditProfilePopup$ = new BehaviorSubject<boolean>(false);

    /** Membership / other flows: show root profile-status popup while not on my-profile */
    profileGatePopupRequest$ = new Subject<'complete_profile' | 'verification_pending' | 'verification_rejected'>();
}
